import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { CdkStepper } from '@angular/cdk/stepper';
import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: CdkStepper, useExisting: forwardRef(() => StepperComponent) }],
  standalone: true,
  imports: [NgFor, NgIf, NgTemplateOutlet]
})
export class StepperComponent extends CdkStepper {
  @Input() public stepperMaxWidth = '100%';

  public setSelectedStep(index: number): void {
    if (!this.linear) {
      this.selectedIndex = index;
    }
  }
}
